export function formatToTwoDigits(n: number): string {
  if (n > 9) {
    return `${n}`;
  }
  return `0${n}`;
}
